<!--
 * @Author: chenming
 * @LastEditors: Yu Weifeng weifeng.yu@gientech.com
 * @Description: 箱线图
-->
<script>
import ChartBase from '../base.vue';
import { isEmpty, isObject } from 'lodash';
/******* echarts *********/
import * as echarts from 'echarts/core';
import {
  TitleComponent,
  DatasetComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { BoxplotChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
echarts.use([
  TitleComponent,
  DatasetComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  BoxplotChart,
  CanvasRenderer,
  UniversalTransition
]);

export default {
  name: 'LcChartBoxPlot',
  mixins: [ChartBase],
  props: {},
  data() {
    return {
      chartClass: ['lc-chart__boxPlot']
    };
  },
  created() {
    // preset
  },
  mounted() {},
  methods: {
    getCurrentEcharts() {
      return echarts;
    },
    processChartData(data) {
      const options = this.mapOptions;
      let transformData = [];
      // 设置了映射字段 或者 数据里有name和value字段
      if (!isEmpty(options) || (isObject(data[0]) && data[0]['name'] && data[0]['value'])) {
        let groupData = {};

        if ((options && options.type) || data[0]['type']) {
          data.forEach(item => {
            //分组
            const groupType = item[options?.type || 'type'];
            groupData[groupType] = groupData[groupType] ?? [];
            groupData[groupType].push(item);
          });
        } else {
          groupData = { boxplot: data };
        }
        Object.keys(groupData).forEach(group => {
          const dimensionGroup = {};
          groupData[group].forEach(item => {
            // x轴
            const dimensionGroupType = item[options?.dimension || 'name'];
            dimensionGroup[dimensionGroupType] = dimensionGroup[dimensionGroupType] ?? [];
            dimensionGroup[dimensionGroupType].push(item);
          });
          let groupValue = [];
          Object.keys(dimensionGroup).forEach(dimensionGroupType => {
            groupValue.push([
              dimensionGroupType,
              ...dimensionGroup[dimensionGroupType].map(item => item[options?.valueMap || 'value'])
            ]);
          });
          transformData.push({ name: group, value: groupValue });
        });
      } else {
        transformData = data;
      }

      this.chartData = transformData;
    },
    processOptions(options) {
      // 没有分组信息时，不需要显示legend
      this.chartData.length < 2 && delete options.legend;
      options.series = this.chartData.map((data, index) => ({
        name: data.name,
        ...options.series,
        datasetIndex: index
      }));
      this.chartOptions = Object.assign({}, options, {
        dataset: this.chartData.map(data => ({
          source: data.value
        }))
      });
    }
  }
};
</script>
